import Vector from "./vector";
import { DataSpecType, } from "./primitive-types";
class DataRenderer {
    constructor(sceneRange, dataZoffset, transformMatrix, projectionConstant) {
        this.sceneRange = sceneRange;
        this.dataZoffset = dataZoffset;
        this.transformMatrix = transformMatrix;
        this.projectionConstant = projectionConstant;
    }
    _projectPoint(x_, y_, z_, i) {
        const { sceneRange, dataZoffset, transformMatrix, projectionConstant } = this;
        const x = x_ / sceneRange;
        const y = y_ / sceneRange;
        const z = z_ / sceneRange + dataZoffset;
        return new Vector(x, y, z, `${i}`)
            .transform(transformMatrix)
            .project(projectionConstant);
    }
    _projectPolygonOrPoints(element) {
        const xs = [];
        const ys = [];
        element.x.forEach((rawX, index) => {
            const point = this._projectPoint(rawX, element.y[index], element.z[index], index);
            xs.push(point.x);
            ys.push(point.y);
        });
        return Object.assign(Object.assign({}, element), { x: xs, y: ys });
    }
    _projectLines(lines) {
        const xs0 = [];
        const ys0 = [];
        const xs1 = [];
        const ys1 = [];
        lines.x0.forEach((rawX0, index) => {
            const points0 = this._projectPoint(rawX0, lines.y0[index], lines.z0[index], index);
            const points1 = this._projectPoint(lines.x1[index], lines.y1[index], lines.z1[index], index);
            xs0.push(points0.x);
            ys0.push(points0.y);
            xs1.push(points1.x);
            ys1.push(points1.y);
        });
        return Object.assign(Object.assign({}, lines), { x0: xs0, y0: ys0, x1: xs1, y1: ys1 });
    }
    render(data) {
        return data.map((element) => {
            switch (element.type) {
                case DataSpecType.polygon:
                case DataSpecType.points:
                    return this._projectPolygonOrPoints(element);
                case DataSpecType.lines:
                    return this._projectLines(element);
            }
        });
    }
}
export default DataRenderer;
